import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceAuthenticationNotificationState = createStateReducer(initialState, {
  [events.authenticateFailed]: (state, error) => ({
    ...state,
    queue: updateNotification(
      {
        key: "authenticate",
        flags: pushIf({
          invalidCredentials: error.areCredentialsInvalid,
          unExpectedError: error.hasUnExpectedError,
        }),
        args: { failure: "true", message: error.message },
      },
      state.queue,
    ),
  }),
});

export { reduceAuthenticationNotificationState };
